import { css } from 'lit'; export default css`:host {  --mds_core_typeahead_mark_font-weight: 700;}`;